import { PersonnelAutomaticAssignmentConfigurationResponse } from '@/modules/configurationModule/detail/automation/personnel/algorithms-selection/services/configuration-personnel-automatic-assignment-configuration/configuration-personnel-automatic-assignment-configuration.dto'
import { ConfigurationAutomaticAssignmentAlgorithmResponse } from '@/modules/configurationModule/detail/automation/personnel/algorithms-definition/services/configuration-automatic-assignment-algorithm/configuration-automatic-assignment-algorithm.dto'
import { store } from '@/store/store'

export interface ConfigurationAutomationPersonnelAlgorithmsSelectionFormState {
    personnelAutomaticAssignment: PersonnelAutomaticAssignmentConfigurationResponse | null
    automaticAssignmentAlgorithms: ConfigurationAutomaticAssignmentAlgorithmResponse[]
    laboratoryId: number
}
export const initialConfigurationAutomationPersonnelAlgorithmsSelectionFormState =
    (): ConfigurationAutomationPersonnelAlgorithmsSelectionFormState => ({
        personnelAutomaticAssignment: null,
        automaticAssignmentAlgorithms: [],
        laboratoryId: store.getters.labId
    })
